// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tbl_search th[data-v-376c4ef1] {vertical-align: top;}\n.tbl_col td.dlay_rmk[data-v-376c4ef1] {white-space: pre-line;}\n", ""]);
// Exports
module.exports = exports;
